"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_DID_LEAVE = exports.EVENT_WILL_LEAVE = exports.EVENT_DID_ENTER = exports.EVENT_WILL_ENTER = void 0;
var EVENT_WILL_ENTER = 'router.willEnter';
exports.EVENT_WILL_ENTER = EVENT_WILL_ENTER;
var EVENT_DID_ENTER = 'router.didEnter';
exports.EVENT_DID_ENTER = EVENT_DID_ENTER;
var EVENT_WILL_LEAVE = 'router.willLeave';
exports.EVENT_WILL_LEAVE = EVENT_WILL_LEAVE;
var EVENT_DID_LEAVE = 'router.didLeave';
exports.EVENT_DID_LEAVE = EVENT_DID_LEAVE;